export enum EOrderTypes {
  DELIVERY = 'delivery',
  PICKUP = 'pickup',
  DOORDASH_DRIVE = 'doordashdrive',
  DINE_IN = 'dinein',
}
